<div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
    <!--begin::Toolbar container-->
    <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
        <!--begin::Page title-->
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <!--begin::Title-->
            <div class="d-flex align-items-center">
                <h1 class="page-heading mt-0 mb-0">
                    <svg width="42" height="27" viewBox="0 0 42 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g filter="url(#filter0_d_3620_1372)">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M32.3028 5.08326C31.7505 5.08326 31.3028 5.53097 31.3028 6.08326V17.5453H27.3636V0.999999C27.3636 0.447714 26.9158 0 26.3636 0H23.9696C23.4173 0 22.9696 0.447715 22.9696 1V17.5453H19.0304V11.5537C19.0304 11.0014 18.5827 10.5537 18.0304 10.5537H15.6364C15.0842 10.5537 14.6364 11.0014 14.6364 11.5537V17.5453H10.6913V8.07453C10.6913 7.52224 10.2436 7.07453 9.69133 7.07453H7.29738C6.74509 7.07453 6.29738 7.52224 6.29738 8.07453V17.5453H4V19H38V17.5453H35.7085V6.08326C35.7085 5.53097 35.2608 5.08326 34.7085 5.08326H32.3028Z" fill="#265D91"/>
                        </g>
                        <defs>
                        <filter id="filter0_d_3620_1372" x="0" y="0" width="42" height="27" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dy="4"/>
                        <feGaussianBlur stdDeviation="2"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3620_1372"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3620_1372" result="shape"/>
                        </filter>
                        </defs>
                        </svg>
                        

                        Evaluation
                </h1>

                <!--begin::Menu-->

            </div>
            <!--end::Title-->
            <!--begin::Breadcrumb-->
            <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted">
                    <a routerLink="/accueil" class="text-muted ">Accueil</a>
                  </li>
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item">
                    <span class="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted">Evaluation</li>
                <li class="breadcrumb-item">
                    <span class="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <li class="breadcrumb-item text-muted">Liste des évaluateurs</li>
                <!--end::Item-->
            </ul>
            <!--end::Breadcrumb-->
        </div>
        <!--end::Page title-->
        <!--begin::Actions-->

        <!--end::Actions-->
    </div>
    <!--end::Toolbar container-->
</div>
<div id="kt_app_content" class="app-content flex-column-fluid mb-4">
    <!--begin::Content container-->
    <div id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Card-->
        <div class="card">
            <!--begin::Card header-->

            <div class="card-body tools">
                <div class="title mb-15">
                    <h4>Liste des évaluateurs </h4>
                </div>
                <div class="container">
                    
                    <form data-kt-search-element="form" class="w-250px position-relative mb-5" autocomplete="off" [formGroup]="searchForm">
                        <!--begin::Hidden input(Added to disable form autocomplete)-->
                        <input type="hidden" />
                        <!--end::Hidden input-->
                        <!--begin::Icon-->
                        <i class="ki-duotone ki-magnifier fs-2 fs-lg-1 text-gray-500 position-absolute top-50  ms-5 translate-middle-y" (click)="searchevaluateur()">
                            <span class="path1"></span>
                            <span class="path2"></span>
                        </i>
                        <!--end::Icon-->
                        <!--begin::Input-->
                        <input type="text" class="form-control form-control-lg form-control-solid px-15 search-input" formControlName="search" value="" placeholder="Search by username, full name or email..." data-kt-search-element="input" />
                        <!--end::Input-->
                        <!--begin::Spinner-->
                        <span class="position-absolute top-50 end-0 translate-middle-y lh-0 d-none me-5" data-kt-search-element="spinner">
                            <span class="spinner-border h-15px w-15px align-middle text-muted"></span>
                        </span>
                        <!--end::Spinner-->
                        <!--begin::Reset-->
                        <span class="btn btn-flush btn-active-color-primary position-absolute top-50 end-0 translate-middle-y lh-0 me-5 d-none" data-kt-search-element="clear">
                            <i class="ki-duotone ki-cross fs-2 fs-lg-1 me-0">
                                <span class="path1"></span>
                                <span class="path2"></span>
                            </i>
                        </span>
                        <!--end::Reset-->
                    </form>

                    <div class="table-responsive mt-15">
                        <table class="table align-middle fs-6 gy-5 style-table" id="list_cra">
                            <thead>
                                <th class="bg1 min-w-125px">
                                    Nom évaluateur
                                </th>
                                <th class="bg2 min-w-125px">
                                    E-mail
                                </th>
                              
                                <th class="bg3 min-w-125px">
                                    Date évaluation
                                </th>
                                <th class="bg4 min-w-125px">
                                    Action
                                </th>
                            </thead>
                            <tbody>
                                <tr *ngFor="let eval of listevaluateur">
                                    <td>
                                        <span class="color-blue">{{ (eval?.candidate?.first_name ?? '---') + ' ' + (eval?.candidate?.last_name ?? '---') }}
                                        </span>
                                    </td>
                                    <td>
                                        <span > {{eval?.candidate?.email?eval?.candidate?.email:'---' }} </span>
                                    </td>
                                    <td>
                                        <span>{{ eval?.created_at | date:'dd-MM-yyyy' }}    </span>
                                    </td>
                                   
                                    <td>
                                        <a class="voir"  [routerLink]="['/candidats/profilecandidatesn',eval.id]">Voir profil</a>  
                                    </td>
                                </tr>
                            

                            </tbody>
                        </table>
                    </div>
                          <!--end::Table-->
                          <div class="pagination" *ngIf="listevaluateur && listevaluateur.length">
                            <app-pagination [data]="listevaluateur" [lengthData]="totalItems" (setPages)="getItems($event)" [currentPageList]="currentPage"> </app-pagination>
                          </div>
                </div>
                  <div class="alert alert-warning text-center mt-5" role="alert"
                  *ngIf="listevaluateur && !listevaluateur.length">
          <img src="/assets/media/errors/no-data.png" alt="" class="mb-5">
          <span class="empty-list">
              La liste est vide
          </span>
      </div>
            </div>
        </div>
  
    </div>
    <!--end::Content container-->
   
</div>

<div class="modal fade" id="add_user" tabindex="-1" aria-hidden="true">
    <!--begin::Modal dialog-->
    <div class="modal-dialog modal-dialog-centered mw-650px">
        <!--begin::Modal content-->
        <div class="modal-content pt-5  pb-15">
            <!--begin::Modal header-->
            <div class="modal-header">
                <!--begin::Modal title-->
                <h2 class="fw-bold">Ajouter rôle</h2>
                <!--end::Modal title-->
                <!--begin::Close-->
                <div id="kt_customers_export_close" class="btn btn-icon btn-sm btn-active-icon-primary">
                    <i class="ki-duotone ki-cross fs-1">
                        <span class="path1"></span>
                        <span class="path2"></span>
                    </i>
                </div>
                <!--end::Close-->
            </div>
            <!--end::Modal header-->
            <!--begin::Modal body-->
            <div class="modal-body mx-5 mx-xl-15 my-7">
                <!--begin::Form-->
                <div class="mb-10">
                    <label for="user">Utilisateur</label>
                    <input type="text" placeholder="Utilisateur" class="form-control mb-3">
                </div>
                <div class="mb-10">
                    <label for="role">Rôle</label>
                    <select class="form-select  mb-3" data-control="select2" data-placeholder="In Progress"
                        data-hide-search="true">
                        <option value="4" selected="selected">Consultant</option>
                        <option value="1">Esn</option>
                        <option value="2">Candidat</option>
                        <option value="3">Admin</option>
                    </select>
                </div>
                <div class="mb-10">
                    <label for="Email">Email</label>
                    <input type="text" placeholder="Utilisateur@gmail.com" class="form-control mb-3">
                </div>
            </div>
            <div class="card-footer mx-5 mx-xl-15 my-7">
                <div class="actions">
                    <a href="#" class="annuler">Annuler</a>
                    <a href="result-compare" routerLink="result-compare" class="confirmer">Confirmer</a>
                </div>
            </div>
            <!--end::Modal body-->
        </div>
        <!--end::Modal content-->
    </div>
    <!--end::Modal dialog-->
</div>